import {
  caseInsensitive293j1l8ok4b2v as caseInsensitive,
  CaseInsensitiveStringghw1fh6uf9mm as CaseInsensitiveString,
} from './Text.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DelegatingMutableSet198sgh8jelkh1 as DelegatingMutableSet } from './DelegatingMutableSet.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  Entry2xmjmyutzoq3p as Entry,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj($this$DelegatingMutableSet) {
  return $this$DelegatingMutableSet.w4m_1;
}
function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0($this$DelegatingMutableSet) {
  return caseInsensitive($this$DelegatingMutableSet);
}
function CaseInsensitiveMap$_get_entries_$lambda_r32w19($this$DelegatingMutableSet) {
  return new (Entry_0())($this$DelegatingMutableSet.m3().w4m_1, $this$DelegatingMutableSet.n3());
}
function CaseInsensitiveMap$_get_entries_$lambda_r32w19_0($this$DelegatingMutableSet) {
  return new (Entry_0())(caseInsensitive($this$DelegatingMutableSet.m3()), $this$DelegatingMutableSet.n3());
}
var CaseInsensitiveMapClass;
function CaseInsensitiveMap() {
  if (CaseInsensitiveMapClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.y4m_1 = LinkedHashMap().bc();
      }
      q2() {
        return this.y4m_1.q2();
      }
      l2o(key) {
        return this.y4m_1.s4(new (CaseInsensitiveString())(key));
      }
      s4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.l2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      m2o(key) {
        return this.y4m_1.u4(caseInsensitive(key));
      }
      u4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.m2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      n1() {
        return this.y4m_1.n1();
      }
      a5() {
        this.y4m_1.a5();
      }
      z4m(key, value) {
        return this.y4m_1.x4(caseInsensitive(key), value);
      }
      x4(key, value) {
        var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
        return this.z4m(tmp, !(value == null) ? value : THROW_CCE());
      }
      a4n(from) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var key = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var value = element.n3();
          this.z4m(key, value);
        }
      }
      z4(from) {
        return this.a4n(from);
      }
      b4n(key) {
        return this.y4m_1.y4(caseInsensitive(key));
      }
      y4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.b4n((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      v4() {
        var tmp = this.y4m_1.v4();
        var tmp_0 = CaseInsensitiveMap$_get_keys_$lambda_ptzlqj;
        return new (DelegatingMutableSet())(tmp, tmp_0, CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0);
      }
      l3() {
        var tmp = this.y4m_1.l3();
        var tmp_0 = CaseInsensitiveMap$_get_entries_$lambda_r32w19;
        return new (DelegatingMutableSet())(tmp, tmp_0, CaseInsensitiveMap$_get_entries_$lambda_r32w19_0);
      }
      w4() {
        return this.y4m_1.w4();
      }
      equals(other) {
        var tmp;
        if (other == null) {
          tmp = true;
        } else {
          tmp = !(other instanceof CaseInsensitiveMap());
        }
        if (tmp)
          return false;
        return equals(other.y4m_1, this.y4m_1);
      }
      hashCode() {
        return hashCode(this.y4m_1);
      }
    }
    initMetadataForClass($, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap()]);
    CaseInsensitiveMapClass = $;
  }
  return CaseInsensitiveMapClass;
}
var EntryClass;
function Entry_0() {
  if (EntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.c4n_1 = key;
        this.d4n_1 = value;
      }
      m3() {
        return this.c4n_1;
      }
      n3() {
        return this.d4n_1;
      }
      hashCode() {
        return (527 + hashCode(ensureNotNull(this.c4n_1)) | 0) + hashCode(ensureNotNull(this.d4n_1)) | 0;
      }
      equals(other) {
        var tmp;
        if (other == null) {
          tmp = true;
        } else {
          tmp = !isInterface(other, Entry());
        }
        if (tmp)
          return false;
        return equals(other.m3(), this.c4n_1) && equals(other.n3(), this.d4n_1);
      }
      toString() {
        return toString(this.c4n_1) + '=' + toString(this.d4n_1);
      }
    }
    initMetadataForClass($, 'Entry', VOID, VOID, [Entry()]);
    EntryClass = $;
  }
  return EntryClass;
}
//region block: exports
export {
  CaseInsensitiveMap as CaseInsensitiveMap3bv985x2xrppt,
};
//endregion

//# sourceMappingURL=CaseInsensitiveMap.mjs.map
